"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.regexp.to-string");
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _courseTwo = _interopRequireDefault(require("@/components/courseTwo.vue"));
var _courseItem = _interopRequireDefault(require("@/components/courseItem.vue"));
var _xnfzItem = _interopRequireDefault(require("@/components/xnfzItem.vue"));
var _courseItemResource = _interopRequireDefault(require("@/components/courseItemResource.vue"));
var _winCourse = _interopRequireDefault(require("@/components/winCourse.vue"));
var _banner = _interopRequireDefault(require("@/components/banner.vue"));
var _search = _interopRequireDefault(require("@/components/search.vue"));
var _newsMenhu = require("@/api/news/newsMenhu");
var _news = require("@/api/news/news");
var _index = require("@/api/virtualSimulationClass/index");
var _recommendCourse = require("@/api/recommendCourse");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// import "../index.less";
var _default = exports.default = {
  components: {
    CourseItem: _courseTwo.default,
    XnfzItem: _xnfzItem.default,
    Banner: _banner.default,
    Search: _search.default,
    WinCourse: _winCourse.default,
    CourseResource: _courseItemResource.default,
    CourseTwo: _courseTwo.default,
    CourseItemT: _courseItem.default
  },
  filters: {
    date: function date(val) {
      if (val) {
        return val.slice(0, 10);
      }
    }
  },
  data: function data() {
    return {
      xuanFuShow: false,
      newsTypeArr: [],
      newsLists1: [],
      newsLists: [],
      // 新闻列表
      noImg: require("@/assets/img/pic.png"),
      actNum: 0,
      curType: 0,
      homeNavList: [{
        name: "专业与课程服务中心",
        img: require("@/assets/img/image/homeNav1.png"),
        url: "/professionalTeaching"
      }, {
        name: "虚拟仿真实训中心",
        img: require("@/assets/img/image/homeNav2.png"),
        url: "/virtual"
      }, {
        name: "教师能力提升中心",
        img: require("@/assets/img/image/homeNav3.png"),
        url: "/teacherPower"
      }, {
        name: "教材资源中心",
        img: require("@/assets/img/image/homeNav4.png"),
        url: "/books"
      }, {
        name: "首都特色教育",
        img: require("@/assets/img/image/homeNav5.png"),
        url: "/communityEducation"
      }],
      listBookData: [],
      listData: [],
      //moni
      newsItem: [],
      newTypeList: [],
      zykList: [],
      courseList: [],
      openCourseList: [],
      CountryList: [],
      virtualList: [],
      teacherList: [],
      query: {
        isPut: 1,
        pageNum: 1,
        pageSize: 5,
        courseName: "",
        majorName: ""
      },
      newsp: [{
        id: "",
        name: "新闻资讯"
      }, {
        id: "",
        name: "通知公告"
      }],
      newspflag: 0,
      naticeLists: [{
        title: "2021年度1+X建设工程质量检测职业技能等级证书（…",
        time: "2022.09.06",
        content: "各省、自治区、直辖市教育厅（教委），各计划单列市教育局，新疆生产建设兵团教育局，有关单位：为做好2022年全国职业院校技能大赛的筹备…"
      }, {
        title: "2021年度1+X建设工程质量检测职业技能等级证书（…",
        time: "2022.09.06",
        content: "各省、自治区、直辖市教育厅（教委），各计划单列市教育局，新疆生产建设兵团教育局，有关单位：为做好2022年全国职业院校技能大赛的筹备…"
      }, {
        title: "2021年度1+X建设工程质量检测职业技能等级证书（…",
        time: "2022.09.06",
        content: "各省、自治区、直辖市教育厅（教委），各计划单列市教育局，新疆生产建设兵团教育局，有关单位：为做好2022年全国职业院校技能大赛的筹备…"
      }],
      // 通知公告
      perp: [{
        id: "",
        name: "专业资源库"
      }, {
        id: "",
        name: "在线精品课"
      }, {
        id: "",
        name: "视频公开课"
      }
      // {
      //   id: "",
      //   name: "推荐课程",
      // },
      ],
      newsForm: {
        businessId: this.$store.getters.provinceId
      },
      newsForm_1: {
        newsTitle: "",
        newsTypeId: "",
        pageNum: 1,
        pageSize: 3
      },
      servelist: [],
      //专业与课程服务中列表
      servelist_2: [],
      //专业与课程服务中列表2
      perpflag: 0,
      xunilist: [],
      //获取虚拟仿真实训中心
      xunitotal: 0,
      //获取虚拟仿真实训中心总数量
      xunipage: 1,
      //
      tealist: [],
      //教师列表
      jiaocailist: [],
      //教材列表
      jiaocaitotal: 0,
      //教材总数量
      jiaocaipage: 1,
      tjList: [],
      //推荐课程列表
      zwList: [],
      navList: [],
      tjQuery: {
        pageNum: 1,
        pageSize: 8,
        flag: '2',
        keyWord: "",
        majorName: ""
      },
      loading: false,
      loading1: false,
      loading2: false
    };
  },
  created: function () {
    var _created = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var courseName;
      return regeneratorRuntime.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            // const loading = this.$loading({
            //   lock: true,
            //   text: "数据加载中...",
            //   spinner: "el-icon-loading",
            //   background: "rgba(0, 0, 0, 0.7)",
            // });
            // document.cookie = "Token=eyJhbGciOiJIUzUxMiJ9.eyJ1c2VyX2lkIjoiNDAyODgzZTQ4MjczYjhkZTAxODI3YmY2ZjVkYzA0NzQiLCJ1c2VyX2tleSI6ImM4ODFhNDM5LWYyOGYtNDZjZC1hZGQwLTUwMzQ5MzBmZmMzOCIsInVzZXJuYW1lIjoiVGVzdDIwMjIxIn0.MjHqyN2B_w5Fmz0fG64uraTet3hJb78sBbYTPKkbiUn0rN3tcRKILIqh-7_P8TzIjHyf4eIXSzxhOfUmN-ZD3w;expires=";
            courseName = (this.$route.query.courseName || "").trim();
            if (courseName) {
              this.query.courseName = courseName;
              this.tjQuery.keyWord = courseName;
            }
            _context.next = 1;
            return this.getNav();
          case 1:
            _context.next = 2;
            return this.getNewsTypeList();
          case 2:
            _context.next = 3;
            return this.getJobList();
          case 3:
            _context.next = 4;
            return this.getxuni_met();
          case 4:
            _context.next = 5;
            return this.gettea();
          case 5:
            _context.next = 6;
            return this.getjiaocai();
          case 6:
            _context.next = 7;
            return this.getZyzyk();
          case 7:
            if (courseName) {
              this.getTjCourseList();
              this.getOpenCourseList();
              this.getCourseList();
            }
            setTimeout(function () {
              // loading.close()
            }, 1500);
            // this.getCourseList();
            // this.getZykList();
            // this.getOpenCourseList();
            // this.getCountryList();
            // this.majorSourceList_met();
            // this.getReceptionList_met();
          case 8:
          case "end":
            return _context.stop();
        }
      }, _callee, this);
    }));
    function created() {
      return _created.apply(this, arguments);
    }
    return created;
  }(),
  watch: {
    "$route.query.courseName": function $routeQueryCourseName(value) {
      var courseName = (value || "").trim();
      this.query.courseName = courseName;
      this.tjQuery.keyWord = courseName;
      this.query.majorName = "";
      this.tjQuery.majorName = "";
      this.xunipage = 1;
      this.jiaocaipage = 1;
      this.getxuni_met();
      this.gettea();
      this.getjiaocai();
      this.getTjCourseList();
      this.getOpenCourseList();
      this.getCourseList();
      this.getZyzyk();
    }
  },
  methods: {
    closeXuanFu: function closeXuanFu() {
      this.xuanFuShow = false;
    },
    toSsearch: function toSsearch(e) {
      console.log("ooo", e);
      this.query.courseName = e.courseName;
      this.tjQuery.keyWord = e.courseName;
      if (e.majorName == "全部") {
        this.query.majorName = "";
        this.tjQuery.majorName = "";
      } else {
        this.query.majorName = e.majorName;
        this.tjQuery.majorName = e.majorName;
      }
      this.xunipage = 1;
      this.jiaocaipage = 1;
      this.getxuni_met(); //获取虚拟仿真实训中心
      this.gettea(); //教师能力提升中心
      this.getjiaocai(); // //教材资源中心
      this.getTjCourseList(); //推荐课程列表
      this.getOpenCourseList();
      this.getCourseList();
      this.getZyzyk();
    },
    getNav: function () {
      var _getNav = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var res;
        return regeneratorRuntime.wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 1;
              return (0, _index.specialClassificationList)();
            case 1:
              res = _context2.sent;
              this.navList = res.rows;
              // this.navList[0].url='/communityEducation',
              // this.navList[1].url='/oldAgeEducation',
              // this.navList[2].url='/learning',
              // this.navList[3].url='/collegeEngineers',
              this.$forceUpdate();
            case 2:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function getNav() {
        return _getNav.apply(this, arguments);
      }
      return getNav;
    }(),
    getTjCourseList: function getTjCourseList() {
      var _this = this;
      //推荐课程列表
      (0, _recommendCourse.recommendList)(this.tjQuery).then(function (res) {
        _this.tjList = res.rows;
      });
    },
    // 获取职位分类
    getJobList: function getJobList() {
      var _this2 = this;
      (0, _index.positionList)().then(function (res) {
        // console.log(res,'zhiweio')
        _this2.zwList = res.rows;
      });
    },
    lookNewsDetail: function lookNewsDetail(i) {
      var type;
      for (var u in this.newsTypeArr) {
        if (this.newsTypeArr[u].id.toString() == i.newsTypeId) {
          // console.log('ppp')
          type = this.newsTypeArr[u].type;
        }
      }
      if (i.newsUrl && i.newsUrl.length > 5) {
        window.open(i.newsUrl, "_blank");
      } else {
        this.$router.push({
          path: "/newsDetail",
          query: {
            id: i.id,
            type: type
          }
        });
      }
    },
    //获取新闻分类
    getNewsTypeList: function getNewsTypeList() {
      var _this3 = this;
      (0, _newsMenhu.newsTypeList)().then(function (res) {
        _this3.newsTypeArr = res.rows;
        if (_this3.newsTypeArr.length > 0) {
          _this3.getnewslist_met(_this3.newsTypeArr[0].id);
        }
      });
    },
    //新闻公告切换
    getnewsp: function getnewsp(item, index) {
      this.newspflag = index;
      this.getnewslist_met(item.id);
    },
    //获取新闻列表
    getnewslist_met: function getnewslist_met(newsTypeId) {
      var _this4 = this;
      this.loading2 = true;
      (0, _newsMenhu.newsListMenhu)({
        upperShelf: 1,
        newsTypeId: newsTypeId,
        pageNum: 1,
        pageSize: 4
      }).then(function (res) {
        _this4.newsLists1 = res.rows.slice(0, 1);
        _this4.newsLists = res.rows.slice(1);
        console.log("新闻列表", _this4.newsLists);
        _this4.loading2 = false;
      });
    },
    //教材列表滚动
    getjiaocaileft: function getjiaocaileft(index) {
      if (index == -1) {
        if (this.jiaocaipage > 1) {
          this.jiaocaipage--;
          this.getjiaocai();
        }
      } else if (index == 1) {
        if (this.jiaocaipage < Math.ceil(this.jiaocaitotal / 4)) {
          this.jiaocaipage += 1;
          this.getjiaocai();
        }
      }
    },
    //教材资源中心
    getjiaocai: function getjiaocai() {
      var _this5 = this;
      (0, _index.getReceptionList)({
        courseName: this.query.courseName,
        courseSource: "",
        courseType: "7",
        pageNum: this.jiaocaipage,
        pageSize: 4,
        projectLevel: "",
        majorName: this.query.majorName,
        show_status: 1
      }).then(function (res) {
        if (res.code == 200) {
          _this5.jiaocailist = res.rows;
          _this5.jiaocaitotal = res.total;
        } else {
          _this5.jiaocailist = [];
          _this5.jiaocaitotal = 0;
        }
      });
    },
    //教师能力提升中心
    gettea: function gettea() {
      var _this6 = this;
      (0, _index.getReceptionList)({
        courseName: this.query.courseName,
        courseSource: "",
        courseType: "8",
        pageNum: 1,
        pageSize: 8,
        projectLevel: "",
        majorName: this.query.majorName,
        show_status: 1,
        year: ""
      }).then(function (res) {
        if (res.code == 200) {
          _this6.tealist = res.rows;
        } else {
          _this6.tealist = [];
        }
        console.log("111", res);
      });
    },
    //获取虚拟仿真实训中心列表滚动
    getleft: function getleft(index) {
      if (index == -1) {
        if (this.xunipage > 1) {
          this.xunipage--;
          this.getxuni_met();
        }
      } else if (index == 1) {
        if (this.xunipage < Math.ceil(this.xunitotal / 4)) {
          this.xunipage += 1;
          this.getxuni_met();
        }
      }
    },
    //获取虚拟仿真实训中心
    getxuni_met: function getxuni_met() {
      var _this7 = this;
      (0, _index.getReceptionList)({
        courseName: this.query.courseName,
        courseSource: "",
        courseType: "14",
        pageNum: this.xunipage,
        pageSize: 4,
        projectLevel: "",
        majorName: this.query.majorName,
        show_status: 1
      }).then(function (res) {
        if (res.code == 200) {
          _this7.xunilist = res.rows;
          _this7.xunitotal = res.total;
        } else {
          _this7.xunilist = [];
          _this7.xunitotal = 0;
        }
      });
    },
    //获取专业与课程服务中心2
    getReceptionList_met: function getReceptionList_met() {
      var _this8 = this;
      (0, _index.getReceptionList)({
        courseName: this.query.courseName,
        courseSource: "",
        courseType: "1",
        pageNum: 1,
        pageSize: 8,
        projectLevel: "",
        majorName: this.query.majorName,
        show_status: 1
      }).then(function (res) {
        if (res.code == 200) {
          _this8.servelist_2 = res.rows;
        } else {
          _this8.servelist_2 = [];
        }
      });
    },
    //获取专业与课程服务中心2
    getReceptionList_met_2: function getReceptionList_met_2() {
      var _this9 = this;
      (0, _index.getReceptionList)({
        courseName: this.query.courseName,
        courseSource: "",
        courseType: "3",
        pageNum: 1,
        pageSize: 8,
        projectLevel: "",
        majorName: this.query.majorName,
        show_status: 1
      }).then(function (res) {
        if (res.code == 200) {
          _this9.servelist_2 = res.data.list;
        } else {
          _this9.servelist_2 = [];
        }
      });
    },
    //专业与课程服务中心
    getperp: function () {
      var _getperp = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee3(index) {
        var _this0 = this;
        return regeneratorRuntime.wrap(function (_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              this.perpflag = index;
              console.log(index);
              if (!(index == 1)) {
                _context3.next = 2;
                break;
              }
              _context3.next = 1;
              return this.getCourseList();
            case 1:
              _context3.next = 5;
              break;
            case 2:
              if (!(index == 2)) {
                _context3.next = 4;
                break;
              }
              _context3.next = 3;
              return this.getOpenCourseList();
            case 3:
              _context3.next = 5;
              break;
            case 4:
              if (index == 3) {
                // this.getReceptionList_met_2();
                this.getTjCourseList();
              } else if (index == 0) {
                this.loading = true;
                //获取推荐课程
                this.getZyzyk().then(function () {
                  _this0.loading = false;
                });
              }
            case 5:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function getperp(_x) {
        return _getperp.apply(this, arguments);
      }
      return getperp;
    }(),
    // 获取专业资源库
    getZyzyk: function () {
      var _getZyzyk = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var _this1 = this;
        return regeneratorRuntime.wrap(function (_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 1;
              return (0, _index.zyzykList)({
                onState: 1,
                pageSize: 8,
                pageNum: 1,
                majorName: this.query.majorName,
                keyWord: this.query.courseName
              }).then(function (res) {
                if (res.code == 200) {
                  _this1.servelist = res.rows;
                }
              });
            case 1:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function getZyzyk() {
        return _getZyzyk.apply(this, arguments);
      }
      return getZyzyk;
    }(),
    //跳转更多页面
    getmore: function getmore(path) {
      this.$router.push(path);
    },
    toSecond: function toSecond(url) {
      if (!url) {
        return this.$notify.info({
          title: "提示",
          message: "该功能正在建设中"
        });
      }
      this.$router.push(url);
    },
    toSourse: function toSourse() {
      this.$router.push("/professionalTeaching");
    },
    // 专业与课程切换
    tabChange: function tabChange(index) {
      this.actNum = index;
      // alert('111')
    },
    // 搜索
    handleSearch: function handleSearch() {},
    // 获取新闻类型
    getNewsType: function getNewsType() {
      var _this10 = this;
      (0, _news.newsTypeByCode)({
        param: this.prCode
      }).then(function (res) {
        if (res.data.length > 0) {
          _this10.newTypeList = res.data;
          _this10.findNews(_this10.newTypeList[0].id);
        }
      });
    },
    // 获取首页精品在线课程
    getCourseList: function getCourseList() {
      var _this11 = this;
      this.loading1 = true;
      (0, _index.getReceptionList)({
        courseName: this.query.courseName,
        courseType: "1",
        schoolId: "",
        pageNum: 1,
        pageSize: 8,
        showStatus: 1,
        majorName: this.query.majorName
      }).then(function (res) {
        console.log(res);
        _this11.servelist_2 = res.rows;
        _this11.loading1 = false;
        // const {
        //   data
        // } = res;
        _this11.courseList = res.list;
      });
    },
    //获取专业资源库
    getZykList: function getZykList() {
      var _this12 = this;
      (0, _index.webList)({
        emceeCompanyname: "",
        ids: [],
        industry: "",
        industryDetail: "",
        majorLevel: "",
        name: "",
        onState: 1,
        pageNum: 1,
        pageSize: 8,
        provinceId: "ed3ece72a5d642e0a5e12cccca842563",
        schoolId: "",
        keyWord: this.query.courseName,
        majorName: this.query.majorName
      }).then(function (res) {
        for (var i in res.data.list) {
          if (res.data.list[i].previewPic && res.data.list[i].previewPic.indexOf("?") !== -1) {
            res.data.list[i].previewPic = res.data.list[i].previewPic.substring(0, res.data.list[i].previewPic.indexOf("?"));
          }
        }
        _this12.zykList = res.data.list;
      });
    },
    getCountryList: function getCountryList() {
      var _this13 = this;
      //国家规划教材数字课程
      (0, _index.getReceptionList)({
        courseName: this.query.courseName,
        courseSource: "",
        pageNum: 1,
        pageSize: 5,
        projectLevel: "",
        provinceId: "ed3ece72a5d642e0a5e12cccca842563",
        courseType: "3",
        schoolId: "",
        majorName: this.query.majorName
      }).then(function (res) {
        _this13.CountryList = res.data.list;
      });
    },
    getOpenCourseList: function getOpenCourseList() {
      var _this14 = this;
      this.loading1 = true;
      (0, _index.getReceptionList)({
        courseName: this.query.courseName,
        majorName: this.query.majorName,
        courseType: "",
        schoolId: "",
        pageNum: 1,
        pageSize: 8,
        courseTypeList: ["2", "3", "4", "5", "6"]
      }).then(function (res) {
        _this14.servelist_2 = res.rows;
        // const {
        //   data
        // } = res;
        _this14.openCourseList = res.list;
        _this14.loading1 = false;
      });
    },
    tabs: function tabs(index, id) {
      this.curType = index;
      this.newsItem = [];
      this.findNews(id);
    },
    // 根据不同类型ID查询不同省份新闻
    findNews: function findNews(id) {
      var _this15 = this;
      (0, _news.newsListByCodeAndType)({
        code: this.prCode,
        newsTypeId: id,
        pageNum: 1,
        pageSize: 4
      }).then(function (res) {
        _this15.newsItem = res.data.list;
      });
    },
    // 查看更多
    lookMoreBtn: function lookMoreBtn(v) {
      this.$router.push(v);
    },
    // 查看详情
    lookDetail: function lookDetail(e) {
      if (e.newsUrl) {
        window.open(e.newsUrl);
      } else {
        this.$router.push({
          path: "/newsDetail",
          query: {
            newsType: "news",
            curIndex: this.curType,
            id: e.id
          }
        });
      }
    },
    open3: function open3() {
      this.$notify.info({
        title: "提示",
        message: "该功能正在建设中"
      });
    },
    // 德育跳转
    deyu: function deyu() {
      this.$router.push({
        path: "/deYu"
      });
      aplus_queue.push({
        action: "aplus.record",
        arguments: ["special_click", "CLK", {
          //以下为事件属性
          cate_special_name: "德育",
          // 轮播图名称
          special_name: ""
        }]
      });
    },
    // 体育跳转
    tiYu: function tiYu() {
      this.$router.push({
        path: "/tiYu"
      });
      aplus_queue.push({
        action: "aplus.record",
        arguments: ["special_click", "CLK", {
          //以下为事件属性
          cate_special_name: "体育",
          // 轮播图名称
          special_name: ""
        }]
      });
    },
    // 美育跳转
    meiyu: function meiyu() {
      this.$router.push({
        path: "/meiYu"
      });
      aplus_queue.push({
        action: "aplus.record",
        arguments: ["special_click", "CLK", {
          //以下为事件属性
          cate_special_name: "美育",
          // 轮播图名称
          special_name: ""
        }]
      });
    },
    // 劳动教育跳转
    laoDong: function laoDong() {
      window.open("https://ldjy.ykt.eduyun.cn/zjldjy");
      aplus_queue.push({
        action: "aplus.record",
        arguments: ["special_click", "CLK", {
          //以下为事件属性
          cate_special_name: "劳动教育",
          // 轮播图名称
          special_name: ""
        }]
      });
    }
  }
};